import { createContext, useContext } from 'react';

export type DockMode = 'docked' | 'collapsed';

// Context for DockableLayout state
interface DockableLayoutContextValue {
  // State
  mode: DockMode;
  width: number;
  isHovered: boolean;
  isTransitioning: boolean;
  isResizing: boolean;

  // Handlers
  setMode: (mode: DockMode) => void;
  setWidth: (width: number) => void;
  setIsHovered: (hovered: boolean) => void;
}

export const DockableLayoutContext =
  createContext<DockableLayoutContextValue | null>(null);

/**
 * Hook to access DockableLayout context values
 */

export const useDockableLayout = () => {
  const context = useContext(DockableLayoutContext);
  return context;
};
